import { inputLabelClasses as muiInputLabelClasses } from '@mui/material';

declare module '@mui/material/InputLabel' {
  interface InputLabelPropsSizeOverrides {
    medium: true;
    large: true;
  }
}

export const inputLabelClasses = {
  ...muiInputLabelClasses,
};
